// components
import { styled, Box, BoxProps, Popper, PopperProps } from '@mui/material';

export const StyledFilterPopperWrapperBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'pinnedRect'
})<BoxProps & { pinnedRect?: { left: number; top: number } | null }>(
  ({ theme, pinnedRect }) => ({
    position: 'fixed',
    top: pinnedRect?.top ?? 0,
    left: pinnedRect?.left ?? 0,
    zIndex: theme.zIndex.modal + 1,
    overflow: 'visible'
  })
);

export const StyledFilterPopperWrapperPopper = styled(Popper, {
  shouldForwardProp: (prop) => prop !== 'customZIndex'
})<PopperProps & { customZIndex?: number }>(({ customZIndex }) => ({
  overflow: 'visible',
  ...(customZIndex ? { zIndex: `${customZIndex} !important` } : {})
}));
